<div class="margin-40">
  <mat-card class="blue-card">
    <mat-card-header class="search-flex-container">
      <mat-icon style="width: 20px; padding-right: 40px" mat-list-icon class="ion ion-md-search"
                color="light"></mat-icon>
      <mat-form-field style="width: 95%">
        <input matInput type="search" placeholder="Suche" [(ngModel)]="searchTerm" (ngModelChange)="filter()">
      </mat-form-field>
      <button mat-icon-button (click)="addUserDialog()">
        <mat-icon mat-list-icon class="ion ion-md-add-circle-outline"></mat-icon>
      </button>
    </mat-card-header>
  </mat-card>

  <table mat-table *ngIf="filteredUserList" [dataSource]="filteredUserList" class="mat-elevation-z8">

    <!-- Name Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> ID</th>
      <td mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Name</th>
      <td mat-cell *matCellDef="let element"> {{element.name}} {{element.surname}}</td>
    </ng-container>

    <!-- USt-Id. Column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> E-Mail</th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

    <!-- Telefonnummer Column -->
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Telefonnummer</th>
      <td mat-cell *matCellDef="let element"> {{element.phone}} </td>
    </ng-container>

    <!-- Erstellungsdatum Column -->
    <ng-container matColumnDef="entryCreated">
      <th mat-header-cell *matHeaderCellDef> Erstellungsdatum</th>
      <td mat-cell *matCellDef="let element"> {{element.entryCreated| date:'dd.MM.yyyy'}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openSingleUser(row)"
        [ngStyle]="row.deleted == '1' && {'background-color': '#E5E5E5'}"></tr>

  </table>


  <div *ngIf="!users$ && !isLoading" class="empty-array">
    <p>
      Es wurden noch keine Benutzer erstellt
    </p>
  </div>

  <div *ngIf="!filteredUserList && isLoading" class="empty-array">
    <mat-spinner></mat-spinner>
  </div>
</div>
